"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
exports.useAcPageDataList = function (config) {
    var _a = config || {}, initialPage = _a.initialPage, initialPageSize = _a.initialPageSize, initialSorts = _a.initialSorts, initialFilter = _a.initialFilter, _b = _a.name, name = _b === void 0 ? 'UseAcPageDataList' : _b;
    var localStoragePageSizeKey = "UseAcPageDataList-" + name + "-pageSize";
    var getLocalStoragePageSize = function () {
        var _pageSize = parseInt(localStorage.getItem(localStoragePageSizeKey), 10);
        if (_pageSize > 0) {
            return _pageSize;
        }
        return undefined;
    };
    var _c = react_1.useState(initialPage || 1), page = _c[0], setPage = _c[1];
    var _d = react_1.useState(initialPageSize || getLocalStoragePageSize() || 30), pageSize = _d[0], setPageSize = _d[1];
    var _e = react_1.useState(initialSorts), sorts = _e[0], setSorts = _e[1];
    var _f = react_1.useState(initialFilter), filter = _f[0], setFilter = _f[1];
    var updateFilter = function (updatedFilter) {
        setPage(1);
        setFilter(updatedFilter);
    };
    var updateSorts = function (updatedSorts) {
        setPage(1);
        setSorts(updatedSorts);
    };
    var resetSorts = function () {
        setPage(1);
        setSorts(initialSorts);
    };
    var updatePageSize = function (updatedPageSize) {
        localStorage.setItem(localStoragePageSizeKey, "" + updatedPageSize);
        setPageSize(updatedPageSize);
    };
    return {
        page: page,
        setPage: setPage,
        pageSize: pageSize,
        setPageSize: updatePageSize,
        sorts: sorts,
        setSorts: setSorts,
        filter: filter,
        updateFilter: updateFilter,
        updateSorts: updateSorts,
        resetSorts: resetSorts,
    };
};
//# sourceMappingURL=UseAcPageDataList.js.map